import angular from 'angular';
import DemoActionsComponent from './demoActions.component';
import { routing as RoutingConfig } from './demoActions.config';
export default angular.module('invision.customercare.customer.demoActions', []).config(RoutingConfig).component('demoActions', DemoActionsComponent).name;